// Featured Reviews
$('[data-section-type="featured-reviews"]').each(function () {
  const $slider = $(this).find('.js-slider');

  $slider.slick({
    autoplay: $slider.data('autoplay'),
    autoplaySpeed: $slider.data('autoplay-speed'),
    fade: true,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1"><path stroke-linecap="round" stroke-linejoin="round" d="M7 16l-4-4m0 0l4-4m-4 4h18"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1"><path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"/></svg></button>',
  });
});

// Image with text overlay
$('[data-section-type="image-with-text-overlay"]').each(function () {
  $(this).find('.js-overlay-text__button').on('click', function (event) {
    const isAnchorLink = $(this).attr('href').startsWith('#');

    if (!isAnchorLink) {
      return;
    }

    event.preventDefault();

    // Smooth scroll
    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top - $('#pageheader').outerHeight(),
    }, 500);
  });
});

// Lineup
$('[data-section-type="lineup"]').each(function () {
  const $this = $(this);
  const $slider = $this.find('.lineup-list');

  const positionArrows = function () {
    const isMobile = $(window).width() <= 767;
    const imageHeight = $this.find('.slick-current .lineup-item__image-wrapper').outerHeight();
    const contentHeight = $this.find('.slick-current .lineup-item__content').outerHeight();
    const arrowHeight = $this.find('.lineup-list .slick-arrow').outerHeight();
    const height = isMobile ? imageHeight : imageHeight + ( (contentHeight / 2) - (arrowHeight / 2) );
    $this.find('.lineup-list .slick-arrow').css({transform: 'translateY('+ height +'px)'});
  };

  $slider.slick({
    autoplay: $slider.data('autoplay'),
    autoplaySpeed: $slider.data('autoplay-speed'),
    fade: true,
    prevArrow: '<button type="button" class="slick-prev slick-arrow--dark slick-arrow--unbordered slick-arrow--large" aria-label="Previous"><svg width="96" height="96" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow--dark slick-arrow--unbordered slick-arrow--large" aria-label="Next"><svg width="96" height="96" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>'
  });

  $(window).resize(theme.debounce(positionArrows, 150));

  setTimeout(function () {
    positionArrows();
  }, 250);
});

// Logo List
$('[data-section-type="logo-list"]').each(function () {
  const $this = $(this);
  const $slider = $this.find('.logo-list');

  const initLogoListSlider = function () {
    $slider.slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 700,
      fade: true,
    });
  };

  const destroyLogoListSlider = function () {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  };

  try {
    window.matchMedia('(max-width: 767px)').addEventListener('change', function (mediaQueryString) {
      if (mediaQueryString.matches) {
        initLogoListSlider();
      } else {
        destroyLogoListSlider();
      }
    });
  } catch (error) {
    // Adds support for Safari <= 13.
    window.matchMedia('(max-width: 767px)').addListener(function (mediaQueryString) {
      if (mediaQueryString.matches) {
        initLogoListSlider();
      } else {
        destroyLogoListSlider();
      }
    });
  }

  if (window.innerWidth <= 767) {
    initLogoListSlider();
  }
});

// Multi-column
$('.section-multi-column .text-column__image').matchHeight();

// Reviews
$('.section-reviews').each(function () {
  const $slider = $(this).find('.js-slider');

  const alignSlides = function () {
    $slider.find('.js-review').matchHeight();
  };

  $slider.slick({
    slidesToShow: 3,
    prevArrow: '<button type="button" class="slick-prev slick-arrow--dark" aria-label="Previous"><svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1"><path stroke-linecap="round" stroke-linejoin="round" d="M7 16l-4-4m0 0l4-4m-4 4h18"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next slick-arrow--dark" aria-label="Next"><svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1"><path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"/></svg></button>',
    responsive: [
        {
            breakpoint: 999,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
  });

  alignSlides();

  $slider.on('breakpoint', function () {
    alignSlides();
  });
});
